import React, { useState, useEffect } from 'react';

function CouponCard({ coupon, onCopy }) {
  const [copied, setCopied] = useState(false);
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const expiry = new Date(coupon.expiryDate);
      const diff = expiry - now;

      if (diff <= 0) {
        setTimeLeft('Expired');
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      if (days > 0) {
        setTimeLeft(`${days} day${days > 1 ? 's' : ''} left`);
      } else if (hours > 0) {
        setTimeLeft(`${hours} hour${hours > 1 ? 's' : ''} left`);
      } else {
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        setTimeLeft(`${minutes} minute${minutes > 1 ? 's' : ''} left`);
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [coupon.expiryDate]);

  const handleCopyCode = () => {
    if (coupon.couponCode) {
      navigator.clipboard.writeText(coupon.couponCode);
      setCopied(true);
      if (onCopy) {
        onCopy('Coupon code copied! 🎉', 'success');
      }
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleRedirect = () => {
    // Use affiliate URL if available, otherwise use regular redirect URL
    const targetUrl = coupon.affiliateUrl || coupon.redirectUrl;
    window.open(targetUrl, '_blank');
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className={`coupon-card ${coupon.isFeatured ? 'featured-deal' : ''}`}>
      {coupon.isFeatured && <div className="featured-badge">⭐ Featured Deal</div>}
      <h3>{coupon.title}</h3>
      <div className="brand">{coupon.brandName}</div>
      
      <div className="badge-container">
        <span className="app-badge">{coupon.appName}</span>
        <span className="category-badge">{coupon.category}</span>
        <span className="verified-badge">✓ Verified</span>
      </div>
      
      <div className="discount">{coupon.discountText}</div>
      
      {coupon.couponCode && (
        <div 
          className={`coupon-code ${copied ? 'copied' : ''}`}
          onClick={handleCopyCode}
        >
          {coupon.couponCode}
          <div style={{ fontSize: '11px', marginTop: '5px', fontWeight: '500' }}>
            {copied ? '✓ Copied!' : 'Click to copy'}
          </div>
        </div>
      )}
      
      {coupon.minOrderValue && (
        <div className="details">💰 Min Order: ₹{coupon.minOrderValue}</div>
      )}
      
      <details style={{ margin: '15px 0', fontSize: '14px' }}>
        <summary style={{ cursor: 'pointer', fontWeight: '600', color: '#667eea' }}>
          📋 How to Avail
        </summary>
        <p style={{ marginTop: '10px', color: '#666', lineHeight: '1.6' }}>
          {coupon.howToAvail}
        </p>
      </details>
      
      <details style={{ margin: '15px 0', fontSize: '14px' }}>
        <summary style={{ cursor: 'pointer', fontWeight: '600', color: '#667eea' }}>
          📜 Terms & Conditions
        </summary>
        <p style={{ marginTop: '10px', color: '#666', lineHeight: '1.6' }}>
          {coupon.termsAndConditions}
        </p>
      </details>
      
      <div className="posted-date">Posted: {formatDate(coupon.createdAt)}</div>
      <div className="expiry">⏰ Expires: {formatDate(coupon.expiryDate)}</div>
      {timeLeft && timeLeft !== 'Expired' && (
        <div className="countdown">⚡ {timeLeft}</div>
      )}
      
      <button onClick={handleRedirect}>Get Deal →</button>
    </div>
  );
}

export default CouponCard;
